import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { type Control } from 'react-hook-form';

import BrazilStateSelectField from '@/components/forms/BrazilStateSelectField';
import OnboardingField from '@/domain/onboarding/components/OnboardingField';
import { type OnboardingFormValues } from '@/domain/onboarding/types';
import { useTranslate } from '@/state/i18n';
import { format } from '@/utils/data';

interface Props {
  control: Control<OnboardingFormValues>;
}

/** Step 2: how Bodyprint reaches the organization and where it runs events. */
const ContactStep = ({ control }: Props) => {
  const t = useTranslate('domain.onboarding.components.ContactStep');

  return (
    <Stack gap={2.5}>
      <Box sx={sx.grid}>
        <OnboardingField control={control} name="contactName" label={t('contactName')} />
        <OnboardingField
          control={control}
          name="contactEmail"
          label={t('contactEmail')}
          type="email"
          autoComplete="email"
        />
        <OnboardingField
          control={control}
          name="contactPhone"
          label={t('contactPhone')}
          optionalLabel={t('optional')}
          placeholder={t('contactPhonePlaceholder')}
          inputMode="tel"
          formatOnBlur={(value) => format.phoneNumber(value)}
        />
        <Box sx={sx.cityRow}>
          <OnboardingField
            control={control}
            name="city"
            label={t('city')}
            optionalLabel={t('optional')}
            placeholder={t('cityPlaceholder')}
          />
          <BrazilStateSelectField
            control={control}
            name="state"
            label={t('state')}
            emptyLabel={t('noState')}
          />
        </Box>
        <OnboardingField
          control={control}
          name="website"
          label={t('website')}
          optionalLabel={t('optional')}
          placeholder="https://"
          inputMode="url"
        />
        <OnboardingField
          control={control}
          name="instagram"
          label={t('instagram')}
          optionalLabel={t('optional')}
          placeholder="@suaorganizacao"
        />
      </Box>
    </Stack>
  );
};

export default ContactStep;

const sx = {
  grid: {
    display: 'grid',
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' },
    gap: 2,
  },
  cityRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 96px',
    gap: 2,
  },
};
